import Banner from "@/components/banners";
import PagePagination from "@/components/page-navigation";
import React from "react";
import { useTranslation } from "react-i18next";

const links = [
  {
    to: "/",
    text: "home",
    className: "natural-4 text-bold size-8",
  },
  {
    to: "/services",
    text: "services",
    className: "natural-2 text-bold size-8",
  },
];

export default function Services() {
  const { t } = useTranslation();

  return (
    <div className="services-page">
      <PagePagination backText={t("back")} links={links} />
      <div className="container">
        <div className="row first-row">
          <div className="col-md-5 pr-md-0 col-12">
            <h6 className="size-6 text-bold lh-32 primary-1 mb-3">
              {t("services_prices")}
            </h6>
            <h4 className="size-4 text-bold mb-3">{t("the_shipping_price")}</h4>
            <span className="size-7 natural-4 lh-24 text-bold ls-0">
              {t("in_addition_you_can_use")}
            </span>
          </div>
          <div className="col-md-7">
            <Banner width="560px" src="/images/computer.png" />
          </div>
        </div>
      </div>
      <div className="page-body">
        <div className="container">
          <div className="row info-row mb-4">
            <div className="col-md-4 col-12">
              <div className="d-flex h-100 flex-column justify-content-between">
                <h4 className="size-4 text-bold natural-3 m-0">
                  {t("consolidation")}
                </h4>
                <h6 className="size-6 text-bold lh-32 primary-4 m-0">
                  {t("free")}
                </h6>
              </div>
            </div>
            <div className="col-md-8 col-12 pr-0">
              <span className="size-7 lh-24 text-bold ls-0 ws-pw">
                {t("will_combine_all_your")}
              </span>
            </div>
          </div>
          <div className="row info-row mb-4">
            <div className="col-md-4 col-12">
              <div className="d-flex h-100 flex-column justify-content-between">
                <h4 className="size-4 text-bold natural-3 m-0">
                  {t("packaging")}
                </h4>
                <h6 className="size-6 text-bold lh-32 primary-4 m-0">
                  {t("$3.5 — $10")}
                </h6>
              </div>
            </div>
            <div className="col-md-8 col-12 pr-0">
              <p className="size-7 lh-24 text-bold ls-0 ws-pw mb-3">
                {t("we_are_always_in_touch")}
              </p>
              <Banner src="/images/boxes.png" />
            </div>
          </div>
          <div className="row info-row">
            <div className="col-md-4 col-12">
              <div className="d-flex h-100 flex-column justify-content-between">
                <h4 className="size-4 text-bold natural-3 m-0">
                  {t("parcel_storage")}
                </h4>
                <h6 className="size-6 text-bold lh-32 primary-4 m-0">
                  {t("incoming_up_to")}
                </h6>
              </div>
            </div>
            <div className="col-md-8 col-12 pr-0">
              <span className="size-7 lh-24 text-bold ls-0 ws-pw">
                {t("store_incoming_parcels")}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="size-9 natural-4 lh-20 ws-pw question">
          {t("want_to_get_quick_answer")}
        </div>
      </div>
    </div>
  );
}
